import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  LinearProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";

function ScienceVideoDialog({
  open,
  onClose,
  values,
  setValues,
  adding,
  uploading,
  progress,
  onSubmit,
}) {
  return (
    <Dialog
      open={open}
      onClose={() => (adding ? null : onClose)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Add Science Video</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Title"
            value={values.title}
            onChange={(e) =>
              setValues((v) => ({ ...v, title: e.target.value }))
            }
            fullWidth
          />
          <Box>
            <Typography variant="caption" sx={{ color: "#64748b", mb: 0.5 }}>
              Video file (mp4/mov)
            </Typography>
            <Box
              sx={{
                border: "1px dashed #cbd5e1",
                borderRadius: 2,
                p: 1.5,
                display: "flex",
                alignItems: "center",
                gap: 1,
                background: "#f8fafc",
              }}
            >
              <Button variant="outlined" component="label">
                Choose file
                <input
                  type="file"
                  accept="video/*"
                  hidden
                  onChange={(e) =>
                    setValues((v) => ({
                      ...v,
                      file: e.target.files?.[0] || null,
                    }))
                  }
                />
              </Button>
              <Typography variant="body2" sx={{ color: "#475569" }}>
                {values.file ? values.file.name : "No file selected"}
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography variant="caption" sx={{ color: "#64748b", mb: 0.5 }}>
              Workbook PDF (optional)
            </Typography>
            <Box
              sx={{
                border: "1px dashed #cbd5e1",
                borderRadius: 2,
                p: 1.5,
                display: "flex",
                alignItems: "center",
                gap: 1,
                background: "#f8fafc",
              }}
            >
              <Button variant="outlined" component="label">
                Choose PDF
                <input
                  type="file"
                  accept="application/pdf"
                  hidden
                  onChange={(e) =>
                    setValues((v) => ({
                      ...v,
                      workbookFile: e.target.files?.[0] || null,
                    }))
                  }
                />
              </Button>
              <Typography variant="body2" sx={{ color: "#475569" }}>
                {values.workbookFile
                  ? values.workbookFile.name
                  : "No file selected"}
              </Typography>
            </Box>
          </Box>
          {uploading && (
            <Box sx={{ mt: 1 }}>
              <LinearProgress variant="determinate" value={progress} />
              <Typography variant="caption" sx={{ color: "#64748b" }}>
                {Math.round(progress)}%
              </Typography>
            </Box>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={adding}>
          Cancel
        </Button>
        <Button variant="contained" disabled={adding || !values.file} onClick={onSubmit}>
          {adding ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ScienceVideoDialog;
